export default __webpack_public_path__ + "static/media/cube.f7f0189c.jpg";